import { Form, FormControlProps, InputGroup } from 'react-bootstrap'
import { BsSearch } from 'react-icons/bs'

export function SearchTextField({
  id,
  size,
  ...props
}: Readonly<FormControlProps>) {
  return (
    <InputGroup size={size}>
      <Form.Control {...props} size={size} aria-describedby={id} />
      <InputGroup.Text id={id}>
        <BsSearch />
      </InputGroup.Text>
    </InputGroup>
  )
}
